export default __webpack_public_path__ + "65138fe6267171a9625fdbea67a686c5.svg";